<template>
  <div class="tab_content tab__more_information">
    <div class="more_information__note vx-row items-center mx-2">
      <!-- <h3 class="mr-2">Reward Point</h3> -->
    </div>

    <div class="vx-row flex w-full">
      <div class="vx-col w-1/4 border-r-2" style="border-right: 1px solid">
        <div>
          <h4 class="text-center mt-2 font-bold">Points Total</h4>
          <vs-input-number
            v-if="clientType === 'create' || isRewardPointEnable"
            class="my-5"
            :value="form.reward_points"
            :min="0"
            :max-decimal="0"
            @input="item => (form.reward_points = Math.round(Math.abs(item)))"
            :step="1"
          />
          <p class="text-center mt-2 text-base" v-else>{{ form.reward_points }}</p>
        </div>

        <div class="vx-row" v-if="clientType !== 'create'">
          <div class="vx-col w-full text-center" v-if="!isRewardPointEnable">
            <vs-button class="mt-2 mr-2 vs-con-loading__container" id="edit-redeem-point-button" type="relief" @click="isRewardPointEnable = true">Edit Points</vs-button>
          </div>
          <div class="vx-col w-full text-center" v-else>
            <vs-button class="mt-2 mr-2 vs-con-loading__container" id="save-redeem-point-button" type="relief" @click="updateReedemPoint" :disable="loading">Save</vs-button>
          </div>
        </div>
      </div>

      <div class="vx-col w-3/4">
        <vs-table stripe pagination :data="rewardPointHistory" :total="totalRewardHistory" @change-page="handleChangePage" :sst="true" :max-items="limit">
          <template slot="thead">
            <vs-th>Sr#</vs-th>
            <vs-th>Date</vs-th>
            <vs-th>Earned</vs-th>
            <vs-th>Redeemed</vs-th>
            <vs-th>Balance</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="i" v-for="(tr, i) in data">
              <vs-td>
                {{ i + 1 }}
              </vs-td>

              <vs-td>
                {{ formatDate(tr.created_at) }}
              </vs-td>

              <vs-td>
                {{ tr.points_type === 'earn' ? tr.points : 0 | currencyFilter }}
              </vs-td>

              <vs-td>
                {{ tr.points_type !== 'earn' ? tr.points : 0 | currencyFilter }}
              </vs-td>

              <vs-td>
                {{ Math.max(0, tr.balance) | currencyFilter }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { dateMixins } from '@/mixins/dateMixins.js'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'RewardPointsTab',

  props: {
    form: Object,
    clientType: String
  },

  mixins: [dateMixins],

  data() {
    return {
      loading: false,
      isRewardPointEnable: false,
      rewardPointHistory: [],
      clientRewardPoints: null,
      page: 1,
      limit: 10
    }
  },

  async mounted() {
    this.clientRewardPoints = this.form.reward_points

    await this.getClientRewardPointHistory()
  },

  computed: {
    ...mapState('client', ['totalRewardHistory'])
  },

  methods: {
    async getClientRewardPointHistory() {
      await this.$store
        .dispatch('client/getRewardSetupHistory', { id: this.$route.params.id, payload: { page: this.page, limit: this.limit } })
        .then(res => {
          this.rewardPointHistory = res.data
        })
        .catch(err => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    handleChangePage(page) {
      this.page = page
      this.getClientRewardPointHistory()
    },

    async updateReedemPoint() {
      const tempPoints = this.form.reward_points
      this.$store
        .dispatch('setting/updateClientOrPatientReedemPoints', {
          id: this.$route.params.id,
          data: {
            type: 'client',
            points: this.form.reward_points - this.clientRewardPoints
          }
        })
        .then(() => {
          this.isRewardPointEnable = false
          this.clientRewardPoints = tempPoints

          this.$vs.notify({
            title: 'Success',
            text: 'Client Reward points updated successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.getClientRewardPointHistory()
        })
        .catch(err => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '.tab__more_information',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('.tab__more_information > .con-vs-loading')
      }
    }
  },

  filters: {
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(Number(value), 2)
    }
  }
}
</script>
